import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { Betreuerabrechnung } from './Betreuerabrechnung';

export const BetreuerabrechnungPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const abrJahrS = urlSearchParams.get('abrJahr');
    const abrJahr = abrJahrS ? parseInt(abrJahrS, 10) : moment().year();

    const abrMoS = urlSearchParams.get('abrMo');
    const abrMo = abrMoS ? parseInt(abrMoS, 10) : moment().year();

    const currentMonth = urlSearchParams.get('currentMonth') === 'true';

    const betreuer = urlSearchParams.get('betreuer') ? parseInt(urlSearchParams.get('betreuer') || '0', 10) : undefined;

    const showFAnteil = urlSearchParams.get('showFAnteil') === 'true';

    return (
        <Betreuerabrechnung
            abrJahr={abrJahr}
            abrMo={abrMo}
            currentMonth={currentMonth}
            betreuer={betreuer}
            showFAnteil={showFAnteil}
            printView
        />
    );
};
